import { transport } from 'config/transport';

export function callApiGetChiCongDoanVung(congdoanvungId, month, year) {
    return transport.get(`/congdoanvung/${congdoanvungId}/thuchi/chicongdoanvung`, { params: { month, year } });
}
